<div class="sentiment-details-subtheme-breakup" [class.sentiment-details-subtheme-breakup--has-selection]="!!selectedThemeId">
  <div class="sentiment-details-subtheme-breakup__header">
    <h4 class="sentiment-details-subtheme-breakup__title">Sub-theme break-up</h4>
    <div
      *ngIf="hasSuggestedSubthemesForSelectedTheme"
      class="sentiment-details-subtheme-breakup__suggested-wrap"
      title="Switch between standard sub-themes and suggested sub-themes"
    >
      <span class="sentiment-details-subtheme-breakup__suggested-label">Suggested</span>
      <button
        type="button"
        class="sentiment-details-subtheme-breakup__switch"
        [class.sentiment-details-subtheme-breakup__switch--on]="showSuggestedSubthemesOnly"
        role="switch"
        [attr.aria-checked]="showSuggestedSubthemesOnly"
        (click)="onSuggestedSubthemesToggle()"
      >
        <span class="sentiment-details-subtheme-breakup__switch-knob"></span>
      </button>
    </div>
  </div>
  <div *ngIf="!selectedThemeId" class="sentiment-details-subtheme-breakup__placeholder">
    Select a theme from Theme break-up to view sub-themes
  </div>
  <ng-container *ngIf="selectedThemeId">
    <div class="sentiment-details-subtheme-breakup__list" *ngIf="subThemeBarRows.length; else noSub">
      <div
        *ngFor="let row of subThemeBarRows; trackBy: trackBySubThemeId"
        class="sentiment-details-subtheme-breakup__item"
        [class.sentiment-details-subtheme-breakup__item--selected]="selectedSubThemeId === row.subThemeId"
      >
        <div class="sentiment-details-subtheme-breakup__item-head">
          <span class="sentiment-details-subtheme-breakup__item-label">{{ row.subThemeName }}</span>
          <span
            class="sentiment-details-subtheme-breakup__info"
            title="View details"
            role="button"
            tabindex="0"
            (click)="onSubThemeInfoClick(row, $event)"
            (keydown.enter)="onSubThemeInfoClick(row, $event)"
            (keydown.space)="$event.preventDefault(); onSubThemeInfoClick(row, $event)"
          >i</span>
        </div>
        <div
          class="sentiment-details-subtheme-breakup__bar sentiment-details-subtheme-breakup__bar--clickable"
          (mousedown)="$event.preventDefault()"
          (click)="onSubThemeClick(row)"
          role="button"
          tabindex="0"
          (keydown.enter)="onSubThemeClick(row)"
          (keydown.space)="$event.preventDefault(); onSubThemeClick(row)"
          title="Click to view trend"
        >
          <span
            class="sentiment-details-subtheme-breakup__seg sentiment-details-subtheme-breakup__seg--positive"
            [style.width.%]="row.positive"
            [title]="'Positive: ' + (row.positive | number:'1.1-1') + '% (' + (row.positiveCount | number) + ')'"
          ></span>
          <span
            class="sentiment-details-subtheme-breakup__seg sentiment-details-subtheme-breakup__seg--neutral"
            [style.width.%]="row.neutral"
            [title]="'Neutral: ' + (row.neutral | number:'1.1-1') + '% (' + (row.neutralCount | number) + ')'"
          ></span>
          <span
            class="sentiment-details-subtheme-breakup__seg sentiment-details-subtheme-breakup__seg--negative"
            [style.width.%]="row.negative"
            [title]="'Negative: ' + (row.negative | number:'1.1-1') + '% (' + (row.negativeCount | number) + ')'"
          ></span>
        </div>
      </div>
    </div>
    <ng-template #noSub>
      <p class="sentiment-details-subtheme-breakup__empty">No sub-themes for this theme</p>
    </ng-template>
  </ng-container>
</div>
